import { Button, Form, Select, Skeleton } from 'antd';
import { useLazyGetAdminRolesQuery } from 'app/services/edpApiV1/admins';
import React, { FC, useEffect, useRef, useState } from 'react';
import { AdminRoles } from 'shared/types/admins.types';

const ROLE = 'role';
const SIZE = 10;

type RoleInputProps = {
  loading?: boolean;
};

const RoleInput: FC<RoleInputProps> = ({ loading }) => {
  const page = useRef<number>(1);
  const [rolesArray, setRolesArray] = useState<AdminRoles[]>([]);
  const [getRoles, roles] = useLazyGetAdminRolesQuery();

  useEffect(() => {
    getRoles({ page: page.current, size: SIZE });
  }, []);

  useEffect(() => {
    if (roles.data) {
      setRolesArray(prev => [...rolesArray, ...roles!.data!.data]);
    }
  }, [roles.data]);

  // бесконечный скролл, запрашиваем роли до момента, пока не придут все
  const handleScroll = (scrollEvent: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const { target } = scrollEvent;
    if (target instanceof HTMLDivElement) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if ((roles.data?.pagination?.total ?? 0) > rolesArray?.length) {
          getRoles({ page: ++page.current, size: SIZE });
        }
      }
    }
  };

  return (
    <Form.Item name={ROLE} label="Роль" rules={[{ required: true, message: 'Выберите роль!' }]}>
      <Select
        placeholder="Выберите роль"
        onPopupScroll={handleScroll}
        filterOption={false}
        loading={loading || roles?.isLoading || roles?.isFetching}
        options={rolesArray.map(org => ({ label: org.name, value: org.id }))}
      />
    </Form.Item>
  );
};

export default RoleInput;
